<mat-icon mat-dialog-close class="btn-close float-right">close</mat-icon>
<mat-dialog-content class="modal" >
    <div class="col-12 mg-0" *ngIf="coberturas.length > 0;else noCoberturas">
        <div class="table-sio w-100 m-auto">
            <div class="row-sio fz-9">
                <div class="cell-sio pb-5x w-30x font-800">
                    &nbsp;
                </div>
                <div class="cell-sio pb-5x maxw-250x font-800">
                    <label class="text-elipsis"> Cobertura </label>
                </div>
                <div class="cell-sio pb-5x text-center font-800">
                    <label class="text-elipsis"> S.A. </label>
                </div>
                <div class="cell-sio pb-5x text-center font-800">
                    <label class="text-elipsis"> Deducible </label>
                </div>
            </div>
            <div class="row-sio fz-8" *ngFor="let cobertura of coberturas;">

                <div class="cell-sio py-5x w-30x font">
                    <mat-icon class="colorIcon mx-5x text-middle icon-hw">done</mat-icon>
                </div>
                <div class="cell-sio py-5x font">
                        <p class="text-elipsis mx-5x" [title]="cobertura.descr">{{cobertura.descr}}</p>
                </div>
                <div class="cell-sio py-5x text-right font">
                    <ng-container *ngIf="(cobertura.descr === 'GASTOS MEDICOS' && (tipo === 9 || tipo === 10)); else coberturas">
                        <label class="text-elipsis mx-5x">$ 20,000.00</label>
                    </ng-container>
                    <ng-template #coberturas>
                        <ng-container *ngIf="validDmRt(cobertura.descr); else changeTexyCobertura">
                            <label class="text-elipsis mx-5x">{{ setTxtDmRt(cobertura.val) }}</label>
                        </ng-container>
                        <ng-template #changeTexyCobertura>
                            <label class="text-elipsis mx-5x">{{formatSA(((cobertura.valDesc) ? cobertura.valDesc : cobertura.val))}}</label>
                        </ng-template>
                    </ng-template>
                </div>
                <div class="cell-sio py-5x text-right font">
                    <label class="text-elipsis mx-5x">{{(cobertura.dedDesc && cobertura.dedDesc != '' && cobertura.dedDesc != '0%') ? cobertura.dedDesc : (cobertura.dedDesc == '0%') ? 'N/A' : (cobertura.ded == '0') ? 'N/A' : formatDED(cobertura.ded)}}</label>
                </div>
            </div>
        </div>
    </div>
    <ng-template #noCoberturas>
        <div class="table-sio list-sio vertical-middle">
            <div class="row-sio">
                <div class="cell-sio text-center py-15x">
                    <label class="text-elipsis" [title]="noCoberturas">No se cuenta con Coberturas</label>
                </div>
            </div>
        </div>
    </ng-template>
</mat-dialog-content>